import { StepupFrequency } from "../../constants";
import { PlanStatus, SIPPlan } from "../../types";
import {
  PlanFrequency,
  SipTransactionOrderPayload,
} from "../../types/transaction";
import { api } from "../axios";

export const fetchSipDataById = (
  investmentAccountGuid: string,
  sipId: string
): Promise<SIPPlan> => {
  return api.get(`xsip/${sipId}/`, {
    params: { investment_account_guid: investmentAccountGuid },
  });
};

export const createSipTransactionApi = (
  payload: SipTransactionOrderPayload
) => {
  return api.post("xsip/", payload);
};

export const deleteSipTransactionApi = ({
  id,
  investment_account_guid,
}: {
  investment_account_guid: string;
  id: number;
}) => {
  return api.delete(`xsip/${id}/`, {
    data: {
      investment_account_guid,
    },
  });
};

export const updateSipTransactionApi = ({
  id,
  ...payload
}: SipTransactionOrderPayload & {
  id: number;
}) => {
  return api.put(`xsip/${id}/`, payload);
};

export const modifySipTransactionApi = ({
  id,
  ...payload
}: SipTransactionOrderPayload & {
  id: number;
}) => {
  return api.post(`xsip/${id}/modify/`, payload);
};

interface PauseResumeTransactionPayload {
  investment_account_guid: string;
  pause_flag: boolean;
  pause_remarks?: string;
}

export const pauseResumeTransactionApi = ({
  xsipID,
  payload,
}: {
  xsipID: number;
  payload: PauseResumeTransactionPayload;
}) => {
  return api.post(`xsip/${xsipID}/pause/`, payload);
};

type SipStatsResponse = {
  breakdown: {
    status: {
      [k in PlanStatus]: {
        count: number;
        installment_amount: string;
      };
    };
    frequency: {
      [k in PlanFrequency]: {
        count: number;
        installment_amount: string;
      };
    };
  };
  total_active_sip_amount: string;
  active_sip_count: number;
  total_invested_amount: number;
  next_installment_date: string;
  frequencies?: string[];
};

export const getSipStats = (
  investmentAccountId: string
): Promise<SipStatsResponse> => {
  return api.get("xsip/stats/", {
    params: { investment_account_guid: investmentAccountId },
  });
};

export function getNextStepupDate(payload: {
  nextInstallmentDate: string;
  stepUpFrequency: StepupFrequency;
  frequency: PlanFrequency;
}): Promise<{ next_step_up_date: string }> {
  return api.get("xsip/next-step-up-date/", {
    params: {
      step_up_frequency: payload.stepUpFrequency,
      next_installment_date: payload.nextInstallmentDate,
      frequency: payload.frequency,
    },
  });
}
